import React from 'react';

import { Container } from './styles';

type ButtonExportProps = {
  disabled: boolean;
  isLoadingExcel: boolean;
  onClick: () => void;
};

const ButtonExport: React.FC<ButtonExportProps> = ({
  disabled,
  isLoadingExcel,
  onClick,
}) => {
  return (
    <Container onClick={onClick} disabled={disabled}>
      {isLoadingExcel ? 'Gerando Arquivo...' : 'Exportar XLS'}
    </Container>
  );
};

export default ButtonExport;
